import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'plan-duracion-config/'; // Ruta relativa al baseURL del backend

// Interface del modelo
// services/planconfigService.ts

export interface PlanDuracionConfig {
    id: number;
    plan: number;
    plan_nombre: string;
    unidad: 'hora' | 'dia';
    dias: number | null;
    horas: number | null;
    reglas_reserva?: Record<string,any>;
    usa_temporizador: boolean;
    descripcion?: string;
    estado: boolean;
    fecha_creacion: string;
}


// Obtener todos los registros
export const fetchPlanDuracionConfigs = async (): Promise<PlanDuracionConfig[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

// Crear un nuevo registro
export const createPlanDuracionConfig = async (data: {
    plan: number;
    unidad: 'hora' | 'dia';
    dias?: number;
    horas?: number;
    descripcion?: string;
    reglas_reserva?: Record<string,any>;
    usa_temporizador?: boolean;
    estado: boolean;
}) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        if(data.reglas_reserva!==undefined)formData.append('reglas_reserva',JSON.stringify(data.reglas_reserva));
        formData.append('plan', data.plan.toString());
        formData.append('unidad', data.unidad);
        if (data.dias !== undefined && data.dias !== null) formData.append('dias', data.dias.toString());
        if (data.horas !== undefined && data.horas !== null) formData.append('horas', data.horas.toString());
        formData.append('usa_temporizador', data.usa_temporizador ? 'true' : 'false');
        if (data.descripcion) formData.append('descripcion', data.descripcion);
        formData.append('estado', data.estado.toString());

        const response = await axiosInstance.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    });
};

// Actualizar un registro existente
export const updatePlanDuracionConfig = async (
    id: number,
    data: {
        plan: number;
        unidad: 'hora' | 'dia';
        dias?: number;
        horas?: number;
    reglas_reserva?: Record<string,any>;
        usa_temporizador?: boolean;
        descripcion?: string;
        estado: boolean;
    }
) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        if(data.reglas_reserva!==undefined)formData.append('reglas_reserva',JSON.stringify(data.reglas_reserva));
        formData.append('plan', data.plan.toString());
        formData.append('unidad', data.unidad);
        if (data.dias !== undefined && data.dias !== null) formData.append('dias', data.dias.toString());
        if (data.horas !== undefined && data.horas !== null) formData.append('horas', data.horas.toString());

        formData.append('usa_temporizador', data.usa_temporizador ? 'true' : 'false');

        if (data.descripcion) formData.append('descripcion', data.descripcion);
        formData.append('estado', data.estado.toString());

        const response = await axiosInstance.put(`${API_URL}${id}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    });
};
// Eliminar un registro
export const deletePlanDuracionConfig = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};



